import * as axios from 'axios';

const { VUE_APP_API_URL } = process.env || {};

export const getSalesManagers = (token) => axios.get(`${VUE_APP_API_URL}/api/v1/admin/sales_managers`, {
  headers: {
    Authorization: `Bearer ${token}`, // send the access token through the 'Authorization' header
  },
});
